import { getConstant } from '../utils';

export const getCalculatorsFed = getConstant('GET_CALCULATORS_FED');
export const getCalculatorFed = getConstant('GET_CALCULATOR_FED');
export const clearCalculatorFed = getConstant('CLEAR_CALCULATOR_FED');
export const addCalculatorFed = getConstant('ADD_CALCULATOR_FED');
export const setParametersCalculatorFed = getConstant('SET_PARAMETERS_CALCULATOR_FED');
export const removeCalculatorFed = getConstant('REMOVE_CALCULATOR_FED');
export const closeCalculatorFed = getConstant('CLOSE_CALCULATOR_FED');
